module.exports = __webpack_public_path__ + "img/logo_white.ce3d98dc.png";